import { useEffect, useRef } from 'react';
import { registerAiActions } from '../lib/aiActions';

/**
 * Registers the current page as READ-ONLY AI context: the assistant receives a
 * compact snapshot (getContext()) with each chat turn so it can answer about
 * what's on screen and navigate accordingly. No ops are applied through a
 * read-only provider — only editor pages register an apply() (via
 * registerAiActions directly). getContext is read through a ref so passing an
 * inline arrow doesn't re-register every render.
 */
export default function useAiPageContext(page, getContext) {
  const ref = useRef(getContext);
  ref.current = getContext;
  useEffect(() => registerAiActions({ page, getContext: () => ref.current() }), [page]);
}
